import Vue from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import * as Sentry from '@sentry/browser';


Vue.mixin({
    components: {
        FontAwesomeIcon
    }
});

if (!mparc.debug) {
    Sentry.init({
      Vue, dsn: "https://0df58012a66741fd89a16943814b8903@o316323.ingest.sentry.io/5797923"
    })
}
